/**
 * Expands "Final Report Delivered" filter to include related terminal statuses (API expects explicit codes).
 */
export function getVqaListStatusFilterPayload(statusSelections) {
  const statusArray = statusSelections || [];
  const hasFinalReportDelivered = statusArray.includes("Final Report Delivered");

  if (hasFinalReportDelivered) {
    const otherStatuses = statusArray.filter(
      (status) => status !== "Final Report Delivered"
    );
    return [
      "Final Report Delivered",
      "Report Anonymized",
      "Report Published to Library",
      ...otherStatuses,
    ];
  }

  return statusArray;
}
